export const Filters = {
    identifier: 'identifier',
    MOR: 'MOR',
    userId: 'userId',
    createdBySystem: 'createdBySystem',
    isDeletable: 'isDeletable',
    groupName: 'groupName',
};
export const enum Relations {
    UsersMerchantsPivot = 'usersMerchantsPivot2'
}

export const text = [
    Filters.identifier,

];
export const single = [
    Filters.isDeletable,
    Filters.createdBySystem,
]
export const multi = [
    Filters.MOR,
    Filters.userId,
    Filters.groupName,
]

export const enum ValueType {
    JsonAssoc = 'json_assoc',
    JsonList = 'json_list',
    Csv = 'csv',
    CsvHour = 'csv_hour',
    CsvSftpFolder = 'csv_sftp_folder',
    CsvInt = 'csv_int',
    String = 'string',
    CsvCountry = 'csv_country',
    CsvCurrency = 'csv_currency',
    Int = 'int',
    Boolean = '0/1',
    DateTime = 'DATE:YYYY-MM-DD HH:II:SS'
};

export const enum SetupIdentifier {
    Mors = 'MORS',
    KycOnOffSwitch = 'KYC_ON_OFF_SWITCH',
    TicketingOnOffSwitch = 'TICKETING_ON_OFF_SWITCH',
    ZendeskTicketingOnOffSwitch = 'ZENDESK_TICKETING_ON_OFF_SWITCH',
    SftpImportConsumersAllowedMerchantsFolders = 'SFTP_IMPORT_CONSUMERS_ALLOWED_MERCHANTS_FOLDERS'
};
